export const TAGS_URL = Object.freeze({
  path: '/tags',
  view: {
    name: 'tag.view',
    path: '/tags/view/:id',
  },
});
